<template>
  <rest-page :fetch-endpoint="fetchEndpoint">
    <conditions-editor
      v-if="model"
      :key="key"
      :preview="true"
      v-model="model.conditions"
      data-model-name="Segment"
      data-model-attribute="conditions"
      attribute-list-data-url="/segment/segment/attribute-list-data"
    />
  </rest-page>
</template>

<script>
import { projectEndpoint } from '@/core/helpers'
import RestPage from '@/common/components/rest/RestPage'
import ConditionsEditor from '@/common/components/ConditionsEditor'

export default {
  components: { ConditionsEditor, RestPage },

  data() {
    return {
      key: new Date().toTimeString(),
      model: null
    }
  },

  computed: {
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `segments/${this.$route.query.id}`,
        handler: data => {
          this.model = data
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/audiences/pages/SegmentTabOverview.vue